// Prioridad de una tarea (0-3, la que normaliza el servidor): SIEMPRE con texto y un
// icono de apoyo, nunca solo en color. Los colores son los tokens *-text, que cumplen
// AA en claro y en oscuro. Sin prioridad (null) no se pinta nada.
const NIVELES = {
  3: { texto: "Urgente", clase: "mt-pr-c", d: "M12 4l9 16H3zM12 10v4" },
  2: { texto: "Alta",    clase: "mt-pr-a", d: "M12 19V6M6 11l6-6 6 6" },
  1: { texto: "Media",   clase: "mt-pr-m", d: null },
  0: { texto: "Baja",    clase: "mt-pr-b", d: "M12 5v13M6 13l6 6 6-6" },
};

export const textoPrioridad = p => NIVELES[p]?.texto || null;

export default function ChipPrioridad({ prioridad }) {
  const n = NIVELES[prioridad];
  if (!n) return null;
  return (
    <span className={`mt-pr ${n.clase}`}>
      {n.d && (
        <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4"
          strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
          <path d={n.d} />
        </svg>
      )}
      {n.texto}
    </span>
  );
}
